export default "__VITE_ASSET__8c10257c__"